export const API_ROOT = (process.env.NODE_ENV === 'production')
  ? 'https://www.futech-tools.com/api/'
  : 'http://192.168.33.20/api/'




// WEBPACK FOOTER //
// ./src/config.js